// src/i18n/en/views/iframes.js
export const iframes = {
  pricing: {
    title: "Preisrechner",
    description:
      "Legen Sie Grundpreise und Zuschläge pro Einheit je Tarif fest; auf der Rechnung erscheint die Steuer als eigene Position.",
    src: "https://player.vimeo.com/video/00000001",
    ariaLabel: "Video: Preisrechner (EN)",
  },
  connectBooking: {
    title: "Booking.com verbinden",
    description:
      "Schritt-für-Schritt-Anleitung, um Ihre Unterkunft über den Channel Manager mit Booking.com zu verbinden.",
    src: "https://player.vimeo.com/video/00000002",
    ariaLabel: "Video: Booking.com verbinden (EN)",
  },
  connectAirbnb: {
    title: "Airbnb verbinden (über Channex)",
    description:
      "Aktivieren Sie die Airbnb-Verbindung in Ihrem PMS über Channex und synchronisieren Sie Verfügbarkeit und Raten.",
    src: "https://player.vimeo.com/video/00000003",
    ariaLabel: "Video: Airbnb verbinden (EN)",
  },
  channexCertification: {
    title: "Channex-Zertifizierung · PMS",
    description:
      "Voraussetzungen und Tests für die PMS-Zertifizierung mit Channex (vollständige Synchronisierung, Preise, Restriktionen).",
    src: "https://player.vimeo.com/video/00000004",
    ariaLabel: "Video: Channex-Zertifizierung (EN)",
  },
  hotelCalendar: {
    title: "Hotelkalender (mehrere Zimmer)",
    description:
      "Verwalten Sie Buchungen nach Zimmertyp und Einheit; vermeiden Sie Überbuchungen mit einer klaren Übersicht.",
    src: "https://player.vimeo.com/video/00000005",
    ariaLabel: "Video: Hotelkalender (EN)",
  },
  apartmentCalendar: {
    title: "Apartment-Kalender",
    description:
      "Sperrzeiten, Tagespreise und Aufenthalte in einem Kalender pro Unterkunft.",
    src: "https://player.vimeo.com/video/00000006",
    ariaLabel: "Video: Apartment-Kalender (EN)",
  },
  guestCheckin: {
    title: "Check-in über WhatsApp",
    description:
      "Gäste scannen ihren Ausweis, durchlaufen die Identitätsprüfung und unterschreiben digital auf dem Handy.",
    src: "https://player.vimeo.com/video/00000007",
    ariaLabel: "Video: Check-in über WhatsApp (EN)",
  },
  identityVerification: {
    title: "Identitätsprüfung und E-Signatur",
    description:
      "Selfie-Abgleich, MRZ-/PDF417-Auslesung und sichere E-Signatur für die Einhaltung der Vorschriften.",
    src: "https://player.vimeo.com/video/00000008",
    ariaLabel: "Video: Identitätsprüfung (EN)",
  },
  smartLocks: {
    title: "Smarte Schlösser",
    description:
      "Senden Sie automatisch Zugangscodes, ohne Schlüssel und ohne Wartezeit. Dynamische Codes werden unterstützt.",
    src: "https://player.vimeo.com/video/00000009",
    ariaLabel: "Video: Smarte Schlösser (EN)",
  },
  reviewsAutomation: {
    title: "Automatisierte Bewertungen",
    description:
      "Planen Sie Erinnerungen für Bewertungen und stärken Sie den Ruf Ihrer Unterkunft.",
    src: "https://player.vimeo.com/video/00000010",
    ariaLabel: "Video: Automatisierte Bewertungen (EN)",
  },
};
